import { FETCH_SITE_INFO } from 'actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_SITE_INFO:
			return action.payload;
		default:
			return state;
	}
};
